import { toast } from "react-toastify";
import axiosInstance from "../../../../../axiosInstance";
import { HRMS_UTILITY_API_URL, HRMS_ATS_API_URL } from "../../../../Constants/baseConstant";
import { getDomain, getUserId } from "../../../Base/helper/baseFunctions";
import { encryptAPIKey, isAlreadyEncrypted } from "./encryptionHelper";

export const GetAIModelHelper = async (params) => {
    return await axiosInstance(`/ancillary/getAIModels`, {
        method: "POST",
        baseURL: HRMS_UTILITY_API_URL,
        data: {
           apiKey: isAlreadyEncrypted(params?.apiKey) ? params?.apiKey : encryptAPIKey(params?.apiKey),
           provider: params?.provider
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            if (params?.showToast) {
                toast.dismiss();
                toast.error(err?.response?.data?.error?.[0]?.message);
            }
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}
export const GetAIProvidersHelper = async () => {
    return await axiosInstance(`/ancillary/getAIProviders`, {
        method: "GET",
        baseURL: HRMS_UTILITY_API_URL,
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message || "Failed to fetch providers");
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const TestModelHelper = async (params) => {
    return await axiosInstance(`/ancillary/testModelKey`, {
        method: "POST",
        baseURL: HRMS_UTILITY_API_URL,
        data: {
           apiKey: isAlreadyEncrypted(params?.apiKey) ? params?.apiKey : encryptAPIKey(params?.apiKey),
           model: params?.model,
           provider: params?.provider
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            if(params?.setting){
                toast.dismiss();
                toast.error(err?.response?.data?.error?.[0]?.message);
            }
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}
// Question Generation Helpers
export const generatePrescreenQuestionsHelper = async (params) => {
    return await axiosInstance(`/ats/generatePrescreenQuestions`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
           workspace_name: getDomain(),
           user_id: getUserId(),
           job_details: params?.job_details
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data?.data?.data } // Extract Python API nested data
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message || "Generation failed");
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const generateVideoQuestionsHelper = async (params) => {
    return await axiosInstance(`/ats/generateVideoQuestions`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
           workspace_name: getDomain(),
           user_id: getUserId(),
           job_details: params?.job_details
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data?.data?.data } // Extract Python API nested data
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message || "Generation failed");
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}
export const GetAITokenConfigHelper = async (params) => {
    return await axiosInstance(`/ancillary/getAITokenConfig`, {
        method: "POST",
        baseURL: HRMS_UTILITY_API_URL,
        data: {
            domain_name: params?.domain_name || getDomain()
        }
    })
        .then((res) => {
            toast.dismiss();
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const AddAITokenConfigHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...")
    return await axiosInstance(`/ancillary/addAITokenConfig`, {
        method: "POST",
        baseURL: HRMS_UTILITY_API_URL,
        data: {
            domain_name: getDomain(),
            ai_type: params?.ai_type,
            ai_token: isAlreadyEncrypted(params?.ai_token) ? params?.ai_token : encryptAPIKey(params?.ai_token),
            ai_token_json : params?.ai_token_json,
            user_id : getUserId(),
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("AI Config Added Successfully")
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const UpdateAITokenConfigHelper = async (params) => {
    toast.dismiss();
    toast.info("Updating...")
    return await axiosInstance(`/ancillary/updateAITokenConfig`, {
        method: "PUT",
        baseURL: HRMS_UTILITY_API_URL,
        data: {
            domain_name: getDomain(),
            ai_type: params?.ai_type,
            ai_token: isAlreadyEncrypted(params?.ai_token) ? params?.ai_token : encryptAPIKey(params?.ai_token),
            ai_token_json : params?.ai_token_json,
            user_id : getUserId(),
            is_selected : params?.is_selected || false,
            ai_token_configuration_fk : params?.ai_token_configuration_fk,
            resume_processor_selection : params?.resume_processor_selection || false,
            profile_scoring_selection : params?.profile_scoring_selection || false,
            jd_generation_selection: params?.jd_generation_selection || false
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("AI Config Updated Successfully")
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const DeleteAITokenConfigHelper = async (params) => {
    toast.dismiss();
    toast.info("Deleting...")
    return await axiosInstance(`/ancillary/deleteAITokenConfig`, {
        method: "DELETE",
        baseURL: HRMS_UTILITY_API_URL,
        data: {
            domain_name: getDomain(),
            ai_token_configuration_fk: params?.ai_token_configuration_fk
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("AI Config Deleted Successfully")
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

